import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import MobileFirstPageStyle from './mobile-first-page.module.scss';

const HeroContent = () => (
  <StaticQuery
    query={graphql`
      query MobileHero {
        contentfulMobileFirstPage {
          mobileFirstReference {
            hero {
              headlineRichText {
                json
              }
              paragraph {
                json
              }
            }
          }
        }
      }
    `}
    render={(data) => (
      <div className={MobileFirstPageStyle.heroContentDiv}>
        <h1 className={MobileFirstPageStyle.heroTitle}>
          {documentToReactComponents(
            data.contentfulMobileFirstPage.mobileFirstReference.hero
              .headlineRichText.json
          )}
        </h1>
        <div className={MobileFirstPageStyle.heroDescription}>
          {documentToReactComponents(
            data.contentfulMobileFirstPage.mobileFirstReference.hero.paragraph
              .json
          )}
        </div>

        <a
          href='https://app.firststringdigital.com/starter-monthly'
          className='hero-btn'
        >
          Start My Free Trial
        </a>
      </div>
    )}
  />
);

export default HeroContent;
